/**
 * Created by Udara Prabath
 * Date: 1/9/2021
 * Using: IntelliJ IDEA
 */
export const leaderBoardColums = [
    {
        label: 'Rank',
        field: 'studentId',
        width: 270
    },
    {
        label:"Student Name",
        sort: 'asc',
        field: "name",
        width: 270
    },
    {
        label :" Marks",
        field: "mark",
        sort: 'asc',
        width: 270
    },

]
